<template lang="pug">
KetchWrapper(name='Dealer locator')
  div(class='px-3 bg-gray-lighter')
    div(class='lg:container py-5')
      h1(class='text-center mt-0') Find a Local Dealer

      div(class='mx-auto w-full lg:max-w-md space-y-3 text-center')
        DealerLocatorBrandSelector(v-if='$sitewideConfig.config.dealerLocatorShowBrandFacet')
        ClientOnly
          DealerLocatorForm

        UniversalLink(
          v-if='$sitewideConfig.config.dealerLocatorInternationalEnabled'
          link='/dealer-locator/international'
          class='relative inline-block text-action font-bold ml-3 pr-6'
        )
          span(class='block triangle triangle-thick') or Select a Country

  div(class='p-3')
    div(class='lg:container')
      DealerLocatorDisplay(show-map show-result-count)
</template>

<script setup lang="ts">
const { translateTemplate } = useTemplateTranslator()
const route = useRoute()
const { $sitewideConfig } = useNuxtApp()

const title = translateTemplate('Dealer Locator [TITLE_SUFFIX]')
const description = translateTemplate(
  'Locate your nearest [SITE] dealer effortlessly with our user-friendly dealer locator. Shop for top-notch truck accessories and parts with ease.'
)
function webPageSchema() {
  return {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    url: `https://${$sitewideConfig.domain}${route.path}`,
    headline: title,
    description,
    publisher: {
      '@type': 'Organization',
      name: $sitewideConfig.config.siteName,
    },
  }
}

useServerHead({
  script: [{ type: 'application/ld+json', innerHTML: webPageSchema(), tagPosition: 'bodyClose' }],
})

useMetaTags({
  title,
  description,
})
</script>
